import { render, staticRenderFns } from "./svgList.vue?vue&type=template&id=28d1d83f&scoped=true&"
import script from "./svgList.vue?vue&type=script&lang=js&"
export * from "./svgList.vue?vue&type=script&lang=js&"
import style0 from "./svgList.vue?vue&type=style&index=0&id=28d1d83f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d1d83f",
  null
  
)

export default component.exports